export const getUserInitials = userName => {
  if (!userName) {
    return 'Gast';
  }
  return userName.split(' ').slice(0, 2).map(nameItem => nameItem[0]).join('');
};
